import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PriceIndexation } from '@classes/article';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-article-indexing-dialog',
  templateUrl: './article-indexing-dialog.component.html',
  styleUrls: ['./article-indexing-dialog.component.scss'],
})
export class ArticleIndexingDialogComponent
  extends DatatableBaseComponent
  implements OnInit, AfterViewInit
{
  public dataSource: MatTableDataSource<PriceIndexation>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort3: MatSort;

  constructor(
    protected uiSrv: UiService,
    public dialogRef: MatDialogRef<ArticleIndexingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { history: PriceIndexation[] },
  ) {
    super(uiSrv);
    this.history = data.history;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource<PriceIndexation>(this.history);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort3;
  }
  pourcentageControl = new FormControl(null, [
    Validators.required,
    Validators.min(0),
    Validators.max(100),
  ]);

  history: PriceIndexation[];

  displayedColumns: string[] = ['createdOn', 'percentage'];

  onValidate() {
    if (this.pourcentageControl.valid) {
      this.dialogRef.close(this.pourcentageControl.value);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
